import { OnlinePaymentServiceCharges } from "./online-payment-service-charges.model";

export class OnlinePaymentConfiguration {
    // Properties
    ReceiverEmail: string;
    MaximumDepositAmount: number;
    OnlinePaymentServiceFeesPaidByParent: boolean;
    StudentFinesAndFeesOnlinePayment: boolean;
    StudentMealOnlinePayment: boolean;
    StaffMealOnlinePayment: boolean;
    EnableMealServiceFee : boolean;
    EnableFineAndFeesServiceFee : boolean;
    OnlinePaymentServiceCharges: OnlinePaymentServiceCharges[];
    Hexea_PCCTID: string;
    PaymentMethod: any;

    // Class Functions
    constructor() {
        this.OnlinePaymentServiceCharges = [];
    }
   }